// TODO update this to import from commons
// import { gql } from '@reverbdotcom/commons/src/gql';
// eslint-disable-next-line no-restricted-imports
import { gql } from '@apollo/client';
import React from 'react';
import { ListingFinancingCalloutFields } from '@reverbdotcom/commons/src/gql/graphql';
import { ListingAffirmCallout, ListingAffirmCalloutFragment } from './ListingAffirmCallout';
import { ListingKlarnaCallout, ListingKlarnaCalloutFragment } from './ListingKlarnaCallout';
import { ListingPayPalCallout } from './ListingPayPalCallout';
import { MAX_PAY_LATER_CALLOUT_AMOUNT_CENTS } from './useExpressPayPal';

type Listing = ListingFinancingCalloutFields.Fragment;

interface Props {
  listing: Listing;
  showKlarnaCallout?: boolean;
  showPaypalCallout?: boolean;
}

export function ListingFinancingCallout({
  listing,
  showKlarnaCallout = false,
  showPaypalCallout = false,
}: Props) {
  const isPaypalCalloutAvailable = usePayPalCalloutAvailability(listing);

  if (listing.acceptedPaymentMethods.includes('klarna_account') && showKlarnaCallout) {
    return (
      <ListingKlarnaCallout
        listing={listing}
      />
    );
  }

  return (
    <div className="d-flex fx-dir-col gap-2">
      {listing.acceptedPaymentMethods.includes('affirm') &&
        <ListingAffirmCallout
          listing={listing}
        />
      }
      {isPaypalCalloutAvailable && showPaypalCallout &&
        <ListingPayPalCallout
          amountTotal={listing.pricing.buyerPrice}
        />
      }
    </div>
  );
}

function usePayPalCalloutAvailability(listing: Listing) {
  return listing.acceptedPaymentMethods.includes('paypal_pay_later') &&
    listing.pricing.buyerPrice.amountCents <= MAX_PAY_LATER_CALLOUT_AMOUNT_CENTS;
}

export const ListingFinancingCalloutFragment = gql`
  fragment ListingFinancingCalloutFields on Listing {
    _id
    acceptedPaymentMethods
    pricing {
      buyerPrice {
        amountCents
        amount
        currency
      }
    }
    ...ListingAffirmCalloutFields
    ...ListingKlarnaCalloutFields
  }
  ${ListingAffirmCalloutFragment}
  ${ListingKlarnaCalloutFragment}
`;
